<script lang="ts">
	// Action tab content for IR_REM-1-remote
</script>

<div class="action-content">
	<h3>Action Content for IR_REM-1-remote</h3>
	<p>This is the action tab content for the IR_REM-1-remote device.</p>
	<!-- Add your specific action content here -->
</div>

<style>
	.action-content {
		padding: 1rem;
	}
</style>
